import { useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CalendarClock, Pencil, Check } from "lucide-react";
import { appointmentStatus, toneClasses, formatDate } from "@/lib/appointment";

export default function NextAppointment({ c, setC, isDoctor }) {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState(c.next_appointment || "");
  const status = appointmentStatus(c.next_appointment);

  const save = async () => {
    try {
      const updated = await api.override(c.id, "next_appointment", val);
      setC(updated);
      setEditing(false);
      toast.success("Next appointment updated");
    } catch (e) {
      toast.error("Could not update appointment");
    }
  };

  return (
    <div className="rounded-md border border-border bg-muted/40 p-3" data-testid="next-appointment">
      <div className="flex items-center justify-between gap-2">
        <span className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          <CalendarClock className="h-3.5 w-3.5" /> Next follow-up
        </span>
        {isDoctor && !editing && (
          <button data-testid="edit-appointment-btn" onClick={() => { setVal(c.next_appointment || ""); setEditing(true); }}
            className="text-muted-foreground hover:text-foreground">
            <Pencil className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
      {editing ? (
        <div className="mt-2 flex items-center gap-2">
          <Input type="date" value={val} onChange={(e) => setVal(e.target.value)} data-testid="appointment-date-input" className="h-8" />
          <Button size="sm" onClick={save} data-testid="save-appointment-btn" className="h-8 px-2">
            <Check className="h-4 w-4" />
          </Button>
        </div>
      ) : c.next_appointment ? (
        <div className="mt-1.5">
          <p className="text-sm font-semibold text-foreground">{formatDate(c.next_appointment)}</p>
          {status && (
            <span className={`mt-1 inline-block rounded-full border px-2 py-0.5 text-xs font-medium ${toneClasses[status.tone]}`}
              data-testid="appointment-status">
              {status.label}
            </span>
          )}
        </div>
      ) : (
        <p className="mt-1.5 text-sm text-muted-foreground">{isDoctor ? "Not set — tap edit to schedule." : "Not scheduled yet."}</p>
      )}
    </div>
  );
}
